(() => {
  const root = document.querySelector('[data-akro-family]');
  if (!root) return;

  // Calcule une hauteur de header “réaliste” pour le sticky
  const header =
    document.querySelector('header') ||
    document.querySelector('[data-header]') ||
    document.querySelector('.header');

  const setHeaderVar = () => {
    const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    root.style.setProperty('--akro-header', `${h}px`);
  };

  setHeaderVar();
  window.addEventListener('resize', setHeaderVar, { passive: true });

  // Bonus: petite amélioration visuelle si besoin plus tard (classe quand visible)
  const cards = root.querySelectorAll('[data-akro-card]');
  if (!('IntersectionObserver' in window) || !cards.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) e.target.classList.add('is-inview');
    });
  }, { threshold: 0.15 });

  cards.forEach(c => io.observe(c));
})();
